// `{ "mobile-down": "(width < 48em)", … }`, the custom media the stylesheets
// use, turned into JS at build time by `postcss/loader.custom-media.js`
import customMedia from "../../postcss/custom-media.css"

export function matchMqBreakpoint(breakpoint) {
  return window.matchMedia(customMedia[breakpoint]).matches
}

export function shouldMqReducedMotion() {
  return window.matchMedia(`(prefers-reduced-motion: reduce)`).matches
}
